import { createApp } from "vue";
import router from "./router";
import i18n from "./locals/index.js";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import App from "./App.vue";
import AOS from "aos";
import "aos/dist/aos.css";

const app = createApp(App);

app.use(ElementPlus);
app.use(router);
app.use(i18n);
app.use(createPinia());
app.mount("#app");

AOS.init({
  duration: 800,
  once: true,
  offset: 120,
  easing: "ease-out-cubic",
  disableMutationObserver: true,
});
